<template>
  <b-card
    class="mb-0"
  >
    <div class="mb-0">
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <h4
            v-if="parent_type !== 'employee' && parent_type !== 'consultant' && parent_type !== 'prospect'"
            class="card-title mb-0 pt-50"
          >Workforce
          </h4>
          <h4
            v-if="parent_type === 'employee'"
            class="card-title mb-0 pt-50"
          >Employees
          </h4>
          <h4
            v-if="parent_type === 'consultant'"
            class="card-title mb-0 pt-50"
          >Consultants
          </h4>
          <h4
            v-if="parent_type === 'prospect'"
            class="card-title mb-0 pt-50"
          >Prospects
          </h4>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="col-xxl-2 offset-xl-4 offset-xxl-0 order-xl-1 order-xxl-0"
        >
          <b-form-group>
            <v-select
              id="parent_type"
              v-model="parent_type"
              :options="parents"
              :reduce="item => item.id"
              :clearable="true"
              placeholder="Select Workforce"
              @input="parentChanged"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="col-xxl-2 order-xl-2 order-xxl-0"
        >
          <b-form-group>
            <v-select
              id="status_id"
              v-model="status_id"
              :options="status"
              :reduce="item => item.id"
              :clearable="true"
              placeholder="Select Status"
              @input="statusChanged"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="8 ml-auto"
          class="col-xxl-5 mb-1"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-input-group>
              <b-form-input
                v-model="searchQuery"
                placeholder="Search"
                @keyup.enter="updateSearchQuery"
              />
              <b-input-group-append>
                <b-button
                  variant="outline-primary"
                  @click="updateSearchQuery"
                >
                  <feather-icon
                    icon="SearchIcon"
                    size="14"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-button
              v-if="parent_type === 'employee'"
              variant="primary"
              class="ml-md-2 min-w-160"
              :to="{ name: 'human-resources-employees-new'}"
            >
              Add Employee
            </b-button>
            <b-button
              v-if="parent_type === 'consultant'"
              variant="primary"
              class="ml-md-1 min-w-160"
              :to="{ name: 'human-resources-consultants-new'}"
            >
              Add Consultant
            </b-button>
            <b-button
              v-if="parent_type === 'prospect'"
              variant="primary"
              class="ml-md-1 min-w-160"
              :to="{ name: 'human-resources-advanced-search'}"
            >
              Advance Search
            </b-button>
            <b-button
              v-if="parent_type === 'prospect'"
              variant="primary"
              class="ml-md-1 min-w-150"
              :to="{ name: 'human-resources-prospects-new'}"
            >
              Add Prospect
            </b-button>
          </div>
        </b-col>
      </b-row>

    </div>

    <vue-good-table
      :columns="parent_type === 'employee' ? columns : parent_type === 'consultant' ? consultantColumns : parent_type === 'prospect' ? prospectColumns : columns"
      :rows="workforceResponse.employees"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <span
          v-if="props.column.field === 'fullName'"
          class="text-nowrap"
        >
          <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.fullName }}</span>
        </span>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <!-- Column: Action -->
        <span
          v-else-if="props.column.field === 'action'"
          class="btn-action"
        >
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item
                v-if="parent_type === 'prospect'"
                :to="{ name: 'human-resources-prospects-apply', params: { id: props.row.id }}"
              >
                <feather-icon icon="SearchIcon" />
                <span class="ml-50">Apply Job</span>
              </b-dropdown-item>
              <b-dropdown-item
                id="edit"
                :to="{ name: parent_type === 'employee' ? 'human-resources-employees-edit' : parent_type === 'consultant' ? 'human-resources-consultants-edit' : parent_type === 'prospect' ? 'human-resources-prospects-edit' : '', params: { id: props.row.id } }"
              >
                <feather-icon icon="Edit2Icon" />
                <span class="ml-50">Edit</span>
              </b-dropdown-item>
              <b-dropdown-item
                id="delete"
                @click="confirmDeleteRecord(props.row)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown>
            <b-link
              id="view"
              :to="{ name: parent_type === 'employee' ? 'human-resources-employees-view' : parent_type === 'consultant' ? 'human-resources-consultants-view' : parent_type === 'prospect' ? 'human-resources-prospects-view' : '', params: { id: props.row.id } }"
            >
              <b-badge
                pill
                variant="light-primary"
              ><feather-icon icon="EyeIcon" />
              </b-badge>
            </b-link>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
      >
        <div class="d-flex justify-content-end flex-wrap">
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="workforceResponse.count"
              first-number
              last-number
              align="right"
              :per-page="1"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BAvatar, BFormGroup, BBadge, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BDropdown, BDropdownItem, BButton, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Employees from '@/js/employees'
import Consultants from '@/js/consultants'
import Prospects from '@/js/prospects'

import LIST from '@/js/lists'

export default {
  name: 'WorkForce',
  components: {
    BFormGroup,
    vSelect,
    BCard,
    BRow,
    BCol,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,

    // vSelect,
  },
  data() {
    return {
      status_id: null,
      status: [],
      parents: [],
      searchQuery: '',
      pageLength: 10,
      dir: false,
      employee: {},
      parent_type: null,
      workforceResponse: {
        employees: [],
        count: 1,
      },
      columns: [
        {
          label: '#',
          field: 'index',
          width: '100px',
          sortable: false,
        },
        {
          label: 'Name',
          field: 'name',
          sortable: false,
        },
        {
          label: 'Join Date',
          field: 'join_date',
          width: '150px',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'status',
          width: '140px',
          sortable: false,
        },
        {
          label: 'Action',
          field: 'action',
          width: '140px',
          sortable: false,
        },
      ],
      consultantColumns: [
        {
          label: '#',
          field: 'index',
          width: '100px',
        },
        {
          label: 'Name',
          field: 'name',
          sortable: false,
        },
        {
          label: 'Employer Name',
          field: 'employer_name',
          sortable: false,
        },
        {
          label: 'Join Date',
          field: 'join_date',
          width: '130px',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'status',
          width: '130px',
          sortable: false,
        },
        {
          label: 'Action',
          field: 'action',
          width: '130px',
          sortable: false,
        },
      ],
      prospectColumns: [
        {
          label: '#',
          field: 'index',
          width: '100px',
        },
        {
          label: 'Name',
          field: 'name',
          sortable: false,
        },
        {
          label: 'Email Address',
          field: 'email_addreess',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'status',
          width: '130px',
          sortable: false,
        },
        {
          label: 'Action',
          field: 'action',
          width: '120px',
          sortable: false,
        },
      ],

      rows: [],
      searchTerm: '',
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.$store.state.query.page
      },
      set(val) {
        this.$store.state.query.page = val
        this.getParentList()
      },
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Active      : 'light-success',
        Inactive    : 'light-danger',
        Terminated  : 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    '$store.state.lists.commonLists': {
      immediate: true,
      handler() {
        LIST.getHRWorkforcePartners(this)
        switch (this.parent_type) {
          case 'employee':
            LIST.getEmployeeStatusFullList(this)
            break
          case 'consultant':
            LIST.getConsultantStatusFullList(this)
            break
          case 'prospect':
            LIST.getProspectStatusFullList(this)
            break
          default:
            break
        }
      },
    },
  },
  created() {
    this.searchQuery = this.$store.state.query.query
    this.status_id = this.$store.state.query.status_id
    this.parent_type = this.$store.state.query.parent_type
    this.workforceResponse.count = this.$store.state.query.page
    this.getParentList()
    LIST.getHRWorkforcePartners(this)
  },
  methods: {
    confirmDeleteRecord(obj) {
      this.$swal({
        title: 'Are you sure?',
        text: `you wan't to delete this ${obj.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteParent(obj.id)
        }
      })
    },
    employeeDeleted() {
      this.getParentList()
      this.$swal({
        icon: 'success',
        title: 'Employee Deleted!',
        text: 'Your Employee has been deleted',
      })
    },
    employeeNotDeleted() {
      this.$swal({
        icon: 'warning',
        title: 'Employee Not Deleted!',
        text: 'Your Employee has been not deleted',
      })
    },
    consultantDeleted() {
      Consultants.getConsultants(this)
      this.$swal({
        icon: 'success',
        title: 'Consultant Deleted!',
        text: 'Your Consultant has been deleted',
      })
    },
    consultantNotDeleted() {
      this.$swal({
        icon: 'warning',
        title: 'Consultant Not Deleted!',
        text: 'Your Consultant has been not deleted',
      })
    },
    prospectDeleted() {
      Prospects.getProspects(this)
      this.$swal({
        icon: 'success',
        title: 'Prospect Deleted!',
        text: 'Your Prospect has been deleted',
      })
    },
    prospectNotDeleted() {
      this.$swal({
        icon: 'warning',
        title: 'Prospect Not Deleted!',
        text: 'Your Prospect has been not deleted',
      })
    },
    setStatus(status) {
      this.status = status
    },
    statusChanged() {
      this.$store.state.query.status_id = this.status_id
      this.currentPage = 1
    },
    updateSearchQuery() {
      this.$store.state.query.query = this.searchQuery
      this.currentPage = 1
    },
    setEmployeeTypes(parents) {
      this.parents = parents
    },
    setEmployees(employeesResponse) {
      this.workforceResponse = employeesResponse
    },
    setConsultants(consultantsResponse) {
      this.workforceResponse.employees = consultantsResponse.consultants
      this.workforceResponse.count = consultantsResponse.count
    },
    setProspects(prospectsResponse) {
      this.workforceResponse.employees = prospectsResponse.prospects
      this.workforceResponse.count = prospectsResponse.count
    },
    parentChanged() {
      this.$store.state.query.parent_type = this.parent_type
      this.workforceResponse.employees = []
      this.status = []
      this.$store.state.query.query = ''
      this.searchQuery = ''
      this.$store.state.query.status_id = null
      this.status_id = null
      this.workforceResponse.count = 1
      this.currentPage = 1
    },
    getParentList() {
      switch (this.parent_type) {
        case 'employee':
          LIST.getEmployeeStatusFullList(this)
          Employees.getEmployees(this)
          break
        case 'consultant':
          LIST.getConsultantStatusFullList(this)
          Consultants.getConsultants(this)
          break
        case 'prospect':
          LIST.getProspectStatusFullList(this)
          Prospects.getProspects(this)
          break
        default:
          break
      }
    },
    deleteParent(id) {
      switch (this.parent_type) {
        case 'employee':
          Employees.delete(this, id)
          break
        case 'consultant':
          Consultants.delete(this, id)
          break
        case 'prospect':
          Prospects.delete(this, id)
          break
        default:
          break
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
